import React from "react";
import { Page, Card, Layout, IndexTable } from "@shopify/polaris";
import { TitleBar } from "@shopify/app-bridge-react";
import { useTranslation } from "react-i18next";

export default function FieldsSkeletonIndex(props) {
  const { t } = useTranslation();
  
  return (
    <Page>
      <TitleBar
        title={t("settings.common.skeleton.customFields")}
        primaryAction={{
          content: t("settings.common.skeleton.addField"),
          url: "/settings/fields/new",
        }}
        breadcrumbs={[{ content: t("settings.common.breadcrumbs.settings") }]}
      />
      <Layout>
        <Layout.Section>
          <Card>
            <IndexTable
              loading={true}
              resourceName={{ 
                singular: t("settings.common.skeleton.field"), 
                plural: t("settings.common.skeleton.fields") 
              }}
              itemCount={90}
              headings={[
                { title: t("settings.common.skeleton.name") },
                { title: t("settings.common.skeleton.contentType") },
                { title: t("settings.common.skeleton.usedIn") },
              ]}
            >
              <tr style={{ height: "var(--p-space-4)" }}></tr>
            </IndexTable>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
